import React, { Suspense } from "react";

import { Switch, Route } from "react-router-dom";

import { useApolloClient } from "react-apollo";
import PageContainer from "../components/PageContainer";

import HomePage from "./HomePage";

import BreadCrumbs from "../components/BreadCrumbs";

/**
 * System Administration
 */
import SystemAdministrationRouter from "./SystemAdministration";
/**
 * Accounting
 */

import AccountingRouter from "./Accounting";
/**
 * Inventory Mangement
 */
import InventoryManagementRouter from "./InventoryManagement";

/**
 * Reports
 */
import ReportsRouter from "./Reports";
/**
 * Dispatch Processing
 */
import DispatchProcessingRouter from "./DispatchProcessing";

/**
 * HR Management
 */
import HRManagementRouter from "./HRManagement";

/**
 * Fleet Management
 */
import FleetManagementRouter from "./FleetManagement";

/**
 *  PTO Processing
 */
import PTOProcessingRouter from "./PTOProcessing";

import { useInterval } from "../hooks";

import { CHECK_AUTH_QUERY } from "../graphql/Auth/Auth.graphql";

function Pages() {
  const client = useApolloClient();

  useInterval(async () => {
    const {
      data: { checkAuth }
    } = await client.query({
      query: CHECK_AUTH_QUERY,
      fetchPolicy: "network-only"
    });
    console.log(`CHECK_AUTH -> ${checkAuth}`);
  }, 6e4);

  return (
    <PageContainer>
      <BreadCrumbs />
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route path="/admin/*">
            <SystemAdministrationRouter />
          </Route>
          <Route path="/dispatch/*">
            <DispatchProcessingRouter />
          </Route>
          <Route path="/fleet/*">
            <FleetManagementRouter />
          </Route>
          <Route path="/inventory/*">
            <InventoryManagementRouter />
          </Route>
          <Route path="/finance/*">
            <AccountingRouter />
          </Route>
          <Route path="/reports/*">
            <ReportsRouter />
          </Route>
          <Route path="/hr/*">
            <HRManagementRouter />
          </Route>
          <Route path="/pto/*">
            <PTOProcessingRouter />
          </Route>
          <Route path="/">
            <HomePage />
          </Route>
        </Switch>
      </Suspense>
    </PageContainer>
  );
}

export default Pages;
